import Marquee from "react-fast-marquee";
import { Star } from "./Star";

export const MarqueeBand = ({ text = "This is how we roll", reverse = false, accent = false }) => {
  const words = Array.from({ length: 6 }, (_, i) => i);
  return (
    <div
      data-testid="marquee-band"
      className={`py-5 md:py-7 border-y-2 border-[#141518] ${
        accent ? "bg-[#F0311B] text-white" : "bg-[#141518] text-white"
      }`}
    >
      <Marquee speed={50} gradient={false} direction={reverse ? "right" : "left"}>
        {words.map((w) => (
          <div key={w} className="flex items-center gap-6 md:gap-10 pr-6 md:pr-10">
            <span className="font-display font-bold italic uppercase text-3xl md:text-5xl tracking-tight whitespace-nowrap">
              {text}
            </span>
            <Star size={22} className={accent ? "text-white" : "text-[#F0311B]"} />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
